enum UploadActualsModalNames {
  StartDate = 'startDate',
  StartDateLabel = 'Date From',
  EndDate = 'endDate',
  EndDateLabel = 'Date To'
}

export default UploadActualsModalNames;
